
export const path = {
    Landing: "/",
    AboutUs: "/aboutus",
    Activities: "/activities"
};